import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import useLocaleRoute from "../../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../../store/StoreProvider";
import CommonListItem from "../../../common/CommonListItem";
import CommonList from "../../../common/CommonList";
//
import Act from "../../../../../../../store/actions";
import urls from "../../../../../../../api/project/ApiUrls";
//

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const StyledList = CommonList;

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const { dataset } = sna;
  // local state
  const [listItems, setListItems] = useState(dataset.public || []);
  const [listItemFocus, setListItemFocus] = useState(null);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  useEffect(() => {
    if (Array.isArray(dataset.public)) {
      setListItems(dataset.public);
    }
  }, [dataset.public]);

  const handleListItemCheckChange = (e, listItem) => {
    const { checked } = e.target;
    const newItems = [];
    listItems.forEach((item) => {
      if (item.id === listItem.id) {
        newItems.push({
          ...item,
          checked,
        });
      } else {
        newItems.push(item);
      }
    });
    setListItems(newItems);
    dispatch({
      type: Act.SNA_CUR_DATASET,
      payload: {
        ...dataset,
        public: [...newItems], // 儲存到 public
      },
    });
  };

  return (
    <StyledList>
      {listItems.map((uFile, idx) => (
        <CommonListItem
          key={idx.toString()}
          withCheckbox
          withAvatar={false}
          checked={uFile.checked}
          onCheckboxChange={handleListItemCheckChange}
          context={{
            id: uFile?.uid,
            textPrimary: uFile.displayName,
          }}
          avatarSize="normal"
          darkMode
        />
      ))}
    </StyledList>
  );
};

export default AccordionDetailChildren;
